export default "__VITE_ASSET__CteCXCYa__"